import { ValidationResult } from "../../../utils/context/FormErrorContext";
import { SAVE_RESULT, RESET_SAVE_RESULT, SET_SAVE_RESULT_SUCCESS, RESET_SAVE_RESULT_ERROR } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";
export interface SaveResultState extends BaseAsyncReducerState {
  success: boolean,
  message: string,
  result?: Record<string, string>[] | ValidationResult;
  loadingCount: number,
  hasError: boolean,
  statuses: number[]
}

const initialState: SaveResultState = {
  success: false,
  message: "",
  loading: false,
  error: false,
  loadingCount: 0,
  hasError: false,
  statuses: []
}

function getSaveResultReducer(state = initialState, action: AppAction | LocalAction) {
  if (action.type === RESET_SAVE_RESULT) {
    return initialState;
  } else if (action.type === SET_SAVE_RESULT_SUCCESS) {
    return { ...state, status: 200, statuses: [200] }
  } else if (action.type === RESET_SAVE_RESULT_ERROR) {
    return { ...state, result: [] }
  } else {
    const { payload } = (action as AppAction)
    let newCount = state.loadingCount
    let allDone = false

    if (action.type === SAVE_RESULT.PENDING) {
      newCount++
      allDone = newCount === 0
    } else {
      newCount--
      allDone = newCount === 0

    }


    switch (action.type) {
      case SAVE_RESULT.PENDING:
        return {
          ...state,
          loading: true,
          loadingCount: newCount,
          success: false,
          error: false,
          hasError: false
        }
      case SAVE_RESULT.SUCCESS:
        return {
          ...state,
          ...payload,
          statuses: [...state.statuses, payload.status ? payload.status : 0],
          loadingCount: newCount,
          loading: !allDone,
          success: allDone && !state.hasError,
          error: state.hasError,
        }
      // Fix PIER2-1829: this action has no payload, so reading from it broke the reducer and left loading stuck
      case SAVE_RESULT.ERROR:
        return {
          ...state,
          statuses: [...state.statuses, payload?.status ? payload.status : 0],
          loadingCount: newCount,
          loading: !allDone,
          success: false,
          error: allDone ? (payload ?? false) : false,
          hasError: true
        };
      default:
        return state
    }
  }

}

export default getSaveResultReducer;